const manageS3 = {
  manageS3: {
    pageTitle: 'Manage S3',
    description: 'Approved Schedule Management / Send S3 link',
    tabs: {
      pending: 'Pending',
      complete: 'Complete'
    }
  }
};

export default manageS3;